import React from 'react'
import '../Css/App.css'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Project_img_1 from '../Images/Recent Commercial projects_CCI_2024.avif'
import Project_img_2 from '../Images/Fairmont Jaipur Main Banquet_Project_Cosy.avif'
import Project_img_3 from '../Images/IMG_4915_JPG.avif'
import Project_img_4 from '../Images/IMG_4917_JPG.avif'
import Range_img_1 from '../Images/image copy.png'
import Range_img_2 from '../Images/image.png'
import Range_img_3 from '../Images/image copy 2.png'
import Range_img_4 from '../Images/image copy 3.png'
import Range_img_5 from '../Images/image copy 4.png'

const Home = () => {
  return (
    <div>
      <Header />

      <section className="hero-classic">
        <div className="hero-overlay">
          <div className="hero-container">
            <div className="hero-content">
              <span className="hero-tagline">Since 1985</span>

              <h1>
                Exporters of Premium & Custom<br />
                Handmade Carpets and Rugs
              </h1>

              <p>
                An exporter of premium and custom handmade carpets and rugs
                manufactured in India. We have been serving clients across the
                globe including USA, Europe, Australia and Japan since 1985.
              </p>

              <p>
                In our next phase, we aim to present our finely crafted collection
                to India’s emerging taste for luxurious living spaces.
              </p>

              <p>
                Explore our retail store and online catalogue to elevate your
                spaces with timeless floor coverings and curated art pieces.
              </p>

              <div className="hero-divider"></div>

              <div className="hero-address">
                <h3>Reach Out to Us</h3>
                <p>
                  H-113, Malviya Industrial Area<br />
                  Near Apex Circle<br />
                  Jaipur, India – 302017
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="product-range">
        <h2 className="product-title">Our Product Range</h2>

        <div className="collage">
          <div className="collage-side">
            <img src={Range_img_1} alt="" />
            <img src={Range_img_2} alt="" />
          </div>

          <div className="collage-center">
            <img src={Range_img_3} alt="" />
          </div>

          <div className="collage-side">
            <img src={Range_img_4} alt="" />
            <img src={Range_img_5} alt="" />
          </div>
        </div>
      </section>

      <section className="projects">
        <h2 className="projects-title">Projects</h2>

        <div className="projects-grid">

          <div className="project-card">
            <img src={Project_img_1} alt="Fairmont Jaipur Rooms" />
            <div className="project-info">
              <span>Luxury Commercial (Hospitality)</span>
              <h3>Fairmont Hotel Jaipur</h3>
              <p>Accor Group of Hotels</p>
              <ul>
                <li><strong>Rooms</strong> 245</li>
                <li><strong>Banquets</strong> 3</li>
                <li><strong>Meeting Room</strong> 1</li>
              </ul>
            </div>
          </div>

          <div className="project-card">
            <img src={Project_img_2} alt="Fairmont Jaipur Banquet" />
            <div className="project-info">
              <span>Large Hospitality Banquet</span>
              <h3>Fairmont Hotel Jaipur</h3>
              <p>Accor Group of Hotels</p>
              <ul>
                <li><strong>3 Large Banquets</strong></li>
              </ul>
            </div>
          </div>

          <div className="project-card">
            <img src={Project_img_3} alt="Raffles Udaipur Lobby" />
            <div className="project-info">
              <span>Luxury Commercial (Hospitality)</span>
              <h3>Raffles Udaipur</h3>
              <ul>
                <li><strong>Rooms</strong> 101+</li>
                <li><strong>Suites</strong> 25+</li>
                <li><strong>Banquets</strong> 3</li>
              </ul>
            </div>
          </div>

          <div className="project-card">
            <img src={Project_img_4} alt="Raffles Udaipur Suite" />
            <div className="project-info">
              <span>Luxury Hospitality (Suites)</span>
              <h3>Raffles Udaipur</h3>
              <ul>
                <li><strong>Suites</strong> 25+</li>
              </ul>
            </div>
          </div>

        </div>
      </section>

      <Footer />

    </div>
  )
}

export default Home